import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Explore from './routes/Explore';
import Save from './routes/Save';
import PlanAtrip from './routes/PlanATrip';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Provider } from "react-redux";
import store from './store/store'

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <div>404 Not Found</div>
  },
  {
    path: "/Explore",
    element: <Explore />,
    errorElement: <div>404 Not Found</div>
  },
  {
    path: "/Save",
    element: <Save />,
    errorElement: <div>404 Not Found</div>
  },
  {
    path: "/PlanATrip",
    element: <PlanAtrip />,
    errorElement: <div>404 Not Found</div>
  },
]);

// Function to update the vh CSS variable based on actual viewport height
const updateViewportHeight = () => {
  // First, get the viewport height and multiply it by 1% to get a value for a vh unit
  const vh = window.innerHeight * 0.01;
  // Then set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

// Update the viewport height on first load and on window resize
updateViewportHeight();
window.addEventListener('resize', updateViewportHeight);
window.addEventListener('orientationchange', updateViewportHeight);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId='328473205423-5nqgorsujjskddahge879ej56q2g5603.apps.googleusercontent.com'>
      <React.StrictMode>
        <RouterProvider router={router} />
      </React.StrictMode>
    </GoogleOAuthProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
